import React from "react";
// import DownloadIcon from "@mui/icons-material/Download";
// import CircularProgress from "@mui/material/CircularProgress";
// import CheckCircleIcon from "@mui/icons-material/CheckCircle";
// import Tooltip from "@mui/material/Tooltip";
// import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { useTheme } from "../../../contexts/ThemeContext";
import { MultiLangText } from "../../../utils/multilang";
import { ProgressIndicator } from "../ProgressIndicator";

const emptyCertificate = { available: false, cmid: null, url: null, label: "-" };
const defaultLabels = {
  noEndDate: "Sin fecha de término",
  download: "Descargar",
  downloading: "Generando...",
  downloaded: "¡Descargado!",
  pending: "Pendiente",
  unavailable: "No disponible",
  certificateUnavailable: "Este curso no cuenta con certificado emitido",
  certificatePending: "Disponible al completar el 100% del curso",
  inProgress: "En progreso",
};

export const ProgressRowItem = ({
  course,
  grade,
  finalGrade,
  progress,
  progressPercent,
  certificate = emptyCertificate,
  downloadStatus = "idle",
  onDownloadCertificate,
  onRowClick,
  labels = defaultLabels,
  includeEncuesta,
  rowIndex = 0,
}) => {
  const theme = useTheme();
  const mergedLabels = { ...defaultLabels, ...labels };
  const isEven = rowIndex % 2 === 1;
  const displayGrade = finalGrade ?? grade ?? "-";
  const resolvedProgress = progressPercent ?? progress ?? null;
  // const hasCertificate = Boolean(certificate?.available || certificate?.cmid || certificate?.url);
  const courseName = course.displayname || course.fullname || course.name || "-";
  const start = course.startdate ? new Date(course.startdate * 1000).toLocaleDateString() : "-";
  const end = course.enddate && Number(course.enddate) !== 0
    ? new Date(course.enddate * 1000).toLocaleDateString()
    : mergedLabels.noEndDate;

  const rowBg = theme.mode === "dark"
    ? (isEven ? "rgba(255,255,255,0.05)" : "rgba(255,255,255,0.02)")
    : (isEven ? "#F5F5F5" : "#FFFFFF");
  const hoverBg = theme.mode === "dark" ? "rgba(255,255,255,0.08)" : "#E8E8E8";
  const titleColor = theme.mode === "dark" ? "#E0E0E0" : "#1A1A1A";
  const textColor = theme.mode === "dark" ? "#B0B0B0" : "#3D3D3D";

  // const handleDownload = (event) => {
  //   event.stopPropagation();
  //   if (hasCertificate && downloadStatus === "idle" && onDownloadCertificate) {
  //     onDownloadCertificate(course.id);
  //   }
  // };

  return (
    <tr
      onClick={() => onRowClick?.(course)}
      className="cursor-pointer transition-colors duration-150"
      style={{ backgroundColor: rowBg }}
      onMouseEnter={(event) => { event.currentTarget.style.backgroundColor = hoverBg; }}
      onMouseLeave={(event) => { event.currentTarget.style.backgroundColor = rowBg; }}
    >
      <th
        scope="row"
        className="p-[16px] font-lato font-medium text-[14px] border-none"
        style={{ color: titleColor }}
      >
        <p className="font-lato font-medium text-[14px] break-words whitespace-normal leading-snug" style={{ color: titleColor }}>
          <MultiLangText content={courseName} />
        </p>
      </th>
      <td className="p-[16px] font-lato text-[14px] border-none whitespace-nowrap text-center" style={{ color: textColor }}>
        <ProgressIndicator value={resolvedProgress} unavailableLabel={mergedLabels.unavailable} />
      </td>
      <td className="p-[16px] font-lato text-[14px] border-none whitespace-nowrap text-center" style={{ color: textColor }}>
        {displayGrade !== "-" && resolvedProgress !== null && resolvedProgress !== undefined && Number(resolvedProgress) < 100 ? (
          <div className="flex flex-col items-center gap-1">
            <span><MultiLangText content={displayGrade} /></span>
            <span
              className="text-[10px] uppercase tracking-wider font-semibold px-1.5 py-0.5 rounded"
              style={{
                backgroundColor: theme.mode === "dark" ? "rgba(245, 158, 11, 0.15)" : "#FEF3C7",
                color: theme.mode === "dark" ? "#FBBF24" : "#B45309",
              }}
            >
              {mergedLabels.inProgress}
            </span>
          </div>
        ) : (
          <span><MultiLangText content={displayGrade} /></span>
        )}
      </td>
      <td className="p-[16px] font-lato text-[14px] border-none whitespace-nowrap" style={{ color: textColor }}>
        <MultiLangText content={start} />
      </td>
      <td className="p-[16px] font-lato text-[14px] border-none whitespace-nowrap" style={{ color: textColor }}>
        <MultiLangText content={end} />
      </td>
      {/* <td className="p-[16px] font-lato text-[14px] border-none whitespace-nowrap z-50" onClick={(event) => event.stopPropagation()}>
        {hasCertificate ? (
          <button
            type="button"
            disabled={downloadStatus !== "idle"}
            onClick={handleDownload}
            className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-[12px] font-semibold transition-all duration-150 select-none ${
              downloadStatus === "loading"
                ? "cursor-wait opacity-80"
                : downloadStatus === "success"
                ? "cursor-default"
                : "cursor-pointer hover:shadow-sm hover:brightness-95 active:scale-95"
            }`}
            style={{
              backgroundColor: downloadStatus === "success"
                ? (theme.mode === "dark" ? "rgba(34, 197, 94, 0.25)" : "#BBF7D0")
                : (theme.mode === "dark" ? "rgba(34, 197, 94, 0.15)" : "#DCFCE7"),
              color: theme.mode === "dark" ? "#4ADE80" : "#15803D",
              border: theme.mode === "dark" ? "1px solid rgba(74, 222, 128, 0.25)" : "1px solid #BBF7D0",
            }}
          >
            {downloadStatus === "loading" && (
              <>
                <CircularProgress size={14} thickness={5} sx={{ color: theme.mode === "dark" ? "#4ADE80" : "#15803D" }} />
                <span>{mergedLabels.downloading}</span>
              </>
            )}
            {downloadStatus === "success" && (
              <>
                <CheckCircleIcon fontSize="small" sx={{ color: theme.mode === "dark" ? "#4ADE80" : "#15803D", fontSize: "16px" }} />
                <span>{mergedLabels.downloaded}</span>
              </>
            )}
            {downloadStatus === "idle" && (
              <>
                <DownloadIcon fontSize="small" sx={{ fontSize: "16px" }} />
                <span>{mergedLabels.download}</span>
              </>
            )}
          </button>
        ) : (
          <Tooltip
            title={Number(resolvedProgress) >= 100 ? mergedLabels.certificateUnavailable : mergedLabels.certificatePending}
            arrow
            placement="top"
          >
            <span
              className="inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-[11px] font-medium cursor-help transition-all hover:opacity-80 select-none"
              style={{
                backgroundColor: theme.mode === "dark" ? "rgba(255, 255, 255, 0.08)" : "#F3F4F6",
                color: theme.mode === "dark" ? "#9CA3AF" : "#6B7280",
                border: theme.mode === "dark" ? "1px solid rgba(255, 255, 255, 0.1)" : "1px solid #E5E7EB",
              }}
            >
              <LockOutlinedIcon style={{ fontSize: "12px" }} />
              <span>{mergedLabels.pending}</span>
            </span>
          </Tooltip>
        )}
      </td> */}
      {includeEncuesta && (
        <td className="p-[16px] font-lato text-[14px] border-none whitespace-nowrap" style={{ color: textColor }}>
          -
        </td>
      )}
    </tr>
  );
};
